'use strict';

var somefilter = require('somefilter/legacy');

var currify = require('currify/legacy');

var isIncludes = currify(function (str, name) {
  return name.includes(str);
});

var isEqual = function isEqual(a) {
  return a && a.length;
};

var limier = somefilter(isEqual, [findByAbr, findByName]);

module.exports = function (pattern, list) {
  check(pattern, list);
  return limier(pattern, list) || [];
};

function findByName(str, names) {
  return names.filter(isIncludes(str));
}

function findByAbr(str, names) {
  var regstr = str.split('').join('.*') + '.*';
  var regexp = RegExp("^".concat(regstr, "$"), 'i');
  var test = regexp.test.bind(regexp);
  return names.filter(test);
}

function check(pattern, list) {
  if (typeof pattern !== 'string') throw Error('pattern should be string!');
  if (!Array.isArray(list)) throw Error('list should be an array!');
}